import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import { requestExportToken } from "../export.service";

const getReportListBooksSectionParty = async (itemToSend) => {
    const token = await requestExportToken("excel/booklist/sectionparty");
    return axios.post(`/api/sbBook/excel/booklist/sectionparty?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportListBooksMilestones = async (itemToSend, bookId) => {
    const token = await requestExportToken("excel/bookswithmilestonslist");
    return axios.post(`/api/sbBook/excel/bookswithmilestonslist/${bookId}?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportSiteUse = async (itemToSend) => {
    const token = await requestExportToken("excel/siteusexcel");
    return axios.post(`/api/sbBook/excel/siteusexcel?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportListUserBooksSectionParty = async (itemToSend) => {
    const token = await requestExportToken("excel/userlist/booksectionparty");
    return axios.post(`/api/sbBook/excel/userlist/booksectionparty?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportCommunications = async (itemToSend, communicationsOpen) => {
    const token = await requestExportToken("excel/communicationlist");
    return axios.post(`/api/sbBook/excel/communicationlist/${communicationsOpen ? 1 : 0}?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

const getReportPendingCommunications = async (itemToSend, bookId) => {
    const token = await requestExportToken("excel/communicationpendinglist");
    return axios.post(`/api/sbBook/excel/communicationpendinglist/${bookId}?exportToken=${token}`, itemToSend, { headers: authHeaderJson() });
};

export {
    getReportListBooksSectionParty,
    getReportSiteUse,
    getReportListUserBooksSectionParty,
    getReportCommunications,
    getReportPendingCommunications,
    getReportListBooksMilestones,
};
